import React, { useEffect } from "react";

import { Anchor, Button, Container, Paper, Stack, Text, Title, useMantineColorScheme } from "@mantine/core";

import { getAuth0URL } from "../api.js";
import {
  editorModalShell,
} from "../styleFile";

const getPaperCard = (isDark) => ({
  borderColor: "var(--mantine-color-default-border)",
  boxShadow: editorModalShell.styles.content.boxShadow,
  backgroundColor: "var(--mantine-color-default)",
});

const LoginPage = () => {
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";
  const paperCard = getPaperCard(isDark);

  const handleLoginClick = () => {
    // getAuth0URL("http://localhost:3000/logging-in").then((res) =>
    getAuth0URL("https://mbxr.io/logging-in").then((res) =>
      window.location.assign(res.authUrl)
    );
  };

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    document.body.setAttribute("data-editor-theme", isDark ? "dark" : "light");
    return () => {
      document.body.removeAttribute("data-editor-theme");
    };
  }, [isDark]);

  return (
    <>
      <style>{`
        @media (min-width: 62em) {
          .mbxr-login-logo {
            max-height: 112px;
            max-width: 180px;
          }
        }
      `}</style>
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "var(--mbx-background-fill, #FAFAF9)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px 16px",
        }}
      >
        <Container p={0} style={{ width: "100%", maxWidth: 420 }}>
          <Paper
            radius={editorModalShell.radius}
            withBorder
            p={{ base: "md", sm: "lg" }}
            style={paperCard}
          >
            <Stack align="center" gap="md">
              <img
                style={{
                  maxHeight: 200,
                  maxWidth: 300,
                }}
                src="/matchboxxrLogo.png"
                className="mbxr-login-logo"
                alt="MatchboxXR logo"
              />
              <Text c="stone" style={editorModalShell.styles.title} ta="center">
                Sign in
              </Text>
              <Title
                order={1}
                ta="center"
                fw={600}
                style={{
                  color: "var(--mantine-color-stone)",
                  fontSize: "1.35rem",
                  letterSpacing: "-0.02em",
                  lineHeight: 1.3,
                }}
              >
                Welcome to matchboxxr!
              </Title>
              <Button
                w="100%"
                size="lg"
                radius={4}
                onClick={handleLoginClick}
                variant="default"
                styles={{
                  root: {
                    backgroundColor: "var(--mantine-color-secondary-outline-hover)",
                    color: "var(--mantine-color-stone)",
                    border: "1px solid var(--mantine-color-default-border)",
                    fontWeight: 500,
                    "&:hover": {
                      backgroundColor: "var(--mantine-color-default-hover)",
                      borderColor: "var(--mantine-color-stone)",
                    },
                  },
                }}
              >
                Login / register
              </Button>
              <Stack gap="xs" mt="xs" w="100%">
                <Text size="sm" c="stone" ta="center" lh={1.55}>
                  This is a 3D ideas tool. It is not designed to secure sensitive information.
                </Text>
                <Text size="sm" c="stone" ta="center" lh={1.55}>
                  This tool is in constant development. Your experience may vary and some data may
                  be changed or lost.
                </Text>
                <Text size="sm" c="stone" ta="center" component="div" lh={1.55}>
                  <Anchor
                    href="https://www.matchboxxr.com/policies"
                    target="_blank"
                    rel="noreferrer"
                    size="sm"
                    c="stone"
                    underline="hover"
                  >
                    Read our Privacy Policy and Terms for more info.
                  </Anchor>
                </Text>
              </Stack>
            </Stack>
          </Paper>
        </Container>
      </div>
    </>
  );
};

export default LoginPage;
